<div class="dialog-container" *ngIf="form">
    <!-- Header -->
    <div class="header-container">
        <div class="header-title">
            {{ isEdit ? 'Edit Year Level' : 'Add Year Level' }}
        </div>
        <div class="close-icon" (click)="onCancel()" [class.disabled]="loading || submitInProgress">
            <img src="assets/images/cross-icon.svg" class="cross-icon" alt="Close" />
        </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="onSave()">
        <div class="form-content">
            <!-- Year Level Name Field -->
            <div class="form-group">
                <app-input 
                    context="Normal" 
                    class="form-item" 
                    label="Year Level Name" 
                    [required]="true"
                    placeholder="Enter year level name" 
                    type="text" 
                    [control]="form.get('yearLevel')"
                    [customErrorMessages]="customErrorMessages.yearLevel"
                    [readonly]="loading || submitInProgress">
                </app-input>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button 
                type="button" 
                class="cancel-button" 
                (click)="onCancel()" 
                [disabled]="loading || submitInProgress"
                [class.disabled]="loading || submitInProgress">
                Cancel
            </button>
            <button 
                type="submit" 
                class="submit-button" 
                [disabled]="loading || submitInProgress"
                [class.loading]="loading || submitInProgress"
                [class.disabled]="loading || submitInProgress">
                <span *ngIf="!loading && !submitInProgress">
                    {{ isEdit ? 'Update' : 'Submit' }}
                </span>
                <span *ngIf="loading || submitInProgress">
                    {{ isEdit ? 'Updating...' : 'Submitting...' }}
                </span>
            </button>
        </div>
    </form>
</div>